import { render, staticRenderFns } from "./DIGIT.vue?vue&type=template&id=5a3d803f&"
import script from "./DIGIT.vue?vue&type=script&lang=js&"
export * from "./DIGIT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports